module.exports = __webpack_public_path__ + "img/ricelog_pinicon_032.862bbb12.png";